import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage';
import nccbanner from "../../../assets/CampuLifeImages/nccbanner.jpg"
import nccactivity1 from "../../../assets/CampuLifeImages/nccactivity1.jpg"
import nccactivity2 from "../../../assets/CampuLifeImages/nccactivity2.jpg"
import nccactivity3 from "../../../assets/CampuLifeImages/nccactivity3.jpg"
import nccactivity4 from "../../../assets/CampuLifeImages/nccactivity4.jpg"



const NCC = () => {
   
   const data = 
    { 
      name:"ncc",
      viewmore:true,
      viewless:true,
      hover:true,
      pagename: "NCC", 
      title: "NCC Activities",
      contentImg:nccbanner,
      para:"T Coy.No 17/11 of 11TN [BN] NCC , Nagercoil [ARMY WING] had raised its sub unit in Noorul Islam College of Arts & Science on 18 th Jan 2021; with the allotted strength of 80 cadets under FSFS Scheme. In 2024 it was promoted to SF scheme with the allotted strength of 104 cadets, based on the seniority and the co-operation with the battalion. The training programmes for the cadets is given through the camp and also  provides various job opportunities for the cadets.The NCC in India is a youth development organization that aims to instill discipline, leadership, and a sense of patriotism among young citizens. ",
      paraone:"The primary aim of the NCC is to develop character, discipline, leadership, a secular outlook, and a spirit of adventure among the youth, while fostering an environment of selfless service to the nation.",
      paranext:"The NCC operates under the motto UNITY and DISCIPLINE , which encapsulates its core philosophy. It is open to school and college students on a voluntary basis and plays a significant role in shaping the youth of India into responsible citizens.",
      nccarraylistTitle:"Objectives : ",
      nccarrayList:[
        {title:"Character Building : ",content:"To instill qualities like integrity, dedication, and a sense of responsibility in cadets, shaping them into disciplined and upright individuals."},
        {title:"National Integration : ",content:"To promote unity and a sense of belonging among youth from diverse cultural, linguistic, and regional backgrounds, fostering a secular and cohesive society."},
        {title:"Service to the Nation : ",content:"To encourage cadets to contribute to community development and nation-building activities, including disaster relief, social service, and awareness campaigns."},
        {title:"Military Training : ",content:"To provide basic military training in areas like drill, weapon handling, and adventure activities, creating an interest in the armed forces as a potential career option."},
        {title:"Adventure and Sports : ",content:"To cultivate a spirit of adventure and teamwork through activities like trekking, mountaineering, sailing, and participation in sports."},
        {title:"Youth Empowerment : ",content:"To equip cadets with life skills, confidence, and resilience to face challenges in personal and professional spheres."},
      ],
      fourhover:true
    }
   
   const hoverContent =[
     {  img: nccactivity1, para1: "International Day Against Drug Abuse & Illicit Trafficking", para2: "June 26, 2023" },
     {  img: nccactivity2, para1: "International Day Against Drug Abuse & Illicit Trafficking", para2: "June 26, 2023" },
     {  img:nccactivity3, para1: "NCC Camp in Thengapattanam", para2: "October 01, 2023" },
     {  img: nccactivity4, para1: "NCC Camp in Thengapattanam", para2: "October 01, 2023" }
 ]
  
 
  return (
    <>
     
      <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
    </>
  )
}

export default NCC